import React from "react";
import { IEventSummary, IScore, IShow } from "@eagerdog/interfaces";

import { NestedSection } from "./NestedSection";
import { BreedGroupSection } from "./BreedGroupSection";
import { groupByBreed, sortGroups } from "./partitionScores";

interface IStream {
  id: "regular" | "altered" | "novice_puppy" | "veteran" | "brace";
  title: string;
  scores: IScore[];
}

interface IProps {
  streams: IStream[];
  event: IEventSummary;
  show: IShow;
  onSaved: () => void;
}

export const BreedsPanel: React.FC<IProps> = ({ streams, event, show, onSaved }) => {
  const visible = streams.filter((stream) => stream.scores.length > 0);
  if (!visible.length) return null;

  return (
    <NestedSection title="Breeds">
      {visible.map((stream) => {
        const grouped = groupByBreed(stream.scores);
        const groups = sortGroups(Array.from(grouped.keys()));
        return (
          <NestedSection key={stream.id} title={stream.title} meta={`${stream.scores.length} entries`}>
            {groups.map((group) => (
              <BreedGroupSection
                key={group}
                breedGroup={group}
                breeds={grouped.get(group) || []}
                event={event}
                show={show}
                onSaved={onSaved}
                card={stream.id}
              />
            ))}
          </NestedSection>
        );
      })}
    </NestedSection>
  );
};
